import { Coupon } from 'utils/types/coupon';
import { PaymentCondition } from 'utils/types/paymentCondition';
import { Client } from 'utils/types/client';
import { newCheckoutInstance } from './instance';

export const getPaymentConditions = async (
    client: Client,
    planSlug: string,
    isWinback: boolean,
    isAmbassador: boolean,
    isBeginner: boolean,
    coupon?: Coupon
): Promise<PaymentCondition[]> => {
    let defaultParams = `?planSlug=${planSlug}`;
    defaultParams += `&isWinback=${isWinback ?? false}&isAmbassador=${
        isAmbassador ?? false
    }&isBeginner=${isBeginner ?? false}`;
    const queryParams = coupon
        ? `${defaultParams}&couponValue=${coupon.value}&couponType=${coupon.couponType}`
        : defaultParams;

    return newCheckoutInstance
        .get(`/v2/paymentConditions${queryParams}`, {
            headers: { Authorization: client.token },
        })
        .then(({ data }) => {
            return data.paymentConditions;
        });
};
